var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKrLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 100",
    style: {
      enableBackground: "new 0 0 500 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28.43,51.97h66.02v7.62H28.43V51.97z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M109.97,56.91l19.12,17.44V75h-10.98l-9.75-8.79V75h-8.08V27.2h8.08v21.06l8.85-7.24h11.5v0.65L109.97,56.91z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M131.67,41.02h8.07v2.33c0.9-1.1,2.78-2.33,7.17-2.33h4.97v7.75h-4.97c-4.65,0-7.17,2.52-7.17,7.43V75h-8.07 V41.02z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M276.78,51.97h66.02v7.62h-66.02V51.97z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M368.59,40.44h8.07v22.09c0,7.56-5.36,12.47-14.34,12.47s-14.34-4.91-14.34-12.47V40.44h8.07v21.19 c0,4.26,2.52,5.94,6.27,5.94s6.27-1.68,6.27-5.94V40.44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M390.94,56.91l-11.05-16.47H389l6.52,9.69l6.46-9.69h9.11l-11.05,16.47l11.69,17.51h-8.98l-7.24-10.79 l-7.3,10.79h-8.98L390.94,56.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M414.97,65.18h8.79v9.24h-8.79V65.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M450.18,40.44h8.08v22.09c0,7.56-5.36,12.47-14.34,12.47s-14.34-4.91-14.34-12.47V40.44h8.07v21.19 c0,4.26,2.52,5.94,6.27,5.94c3.75,0,6.27-1.68,6.27-5.94V40.44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M463.43,25h8.14v8.91h-8.14V25z M463.49,40.44h8.07v33.98h-8.07V40.44z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKrLogo);
export default __webpack_public_path__ + "static/media/kr-logo.41b4a8bf028fb5b893d94e0a12fb29d9.svg";
export { ForwardRef as ReactComponent };